<template>
  <div class="video padding80">
    <Header :current="0"></Header>
    <Card cardIndex="1" ref="Card"></Card>
    <LeiMon :LeiMonList="LeiMonList" @moreModel="moreModel"></LeiMon>
    <Footer></Footer>
  </div>
</template>

<script>
import cardMixins from "@/mixins/cardMixins";

export default {
  name: "videoCenter",
  mixins: [cardMixins],
  data() {
    return {
      LeiMonList: [
        {
          icon: require("../../assets/video/video1.png"),
          iconPosition: "left",
          title: "视频直播",
          tips:
            "为银行及中小企业打造自己的私域视频直播平台，专注服务私域流量用户，实现转化率与营收的提升。",
          more: "",
          type: "liveVideo",
          id: "images0",
          changeType: true
        },
        {
          icon: require("../../assets/video/video2.png"),
          iconPosition: "right",
          title: "视频柜员",
          tips:
            "打破传统物理网点对银行服务延伸的束缚，可随时随地与银行柜员联动，视频语音就可办理业务，客户体验更佳。",
          more: "",
          type: "videoTeller",
          id: "images1",
          changeType: false
        },
        {
          icon: require("../../assets/video/video3.png"),
          iconPosition: "left",
          title: "视频面签",
          tips:
            "徕檬推出的远程签约系统，实现零摩擦业务办理，支持合同视频快速签订，可极大提升客户经理工作效率与用户体验。",
          more: "",
          type: "videoFaceToFace",
          id: "images2",
          changeType: false
        },
        {
          icon: require("../../assets/video/video4.png"),
          iconPosition: "right",
          title: "视频会议",
          tips:
            "突破物理限制，随时随地组织、发起远程视频会议，实现无接触办公。私有化部署，会议内容（视频、音频）安全、保密。",
          more: "",
          type: "videoconferencing",
          id: "images3",
          changeType: false
        },
        {
          icon: require("../../assets/video/video5.png"),
          iconPosition: "left",
          title: "视频诊疗",
          tips:
            "金融机构通过自身的资源整合，为高端客户提供名医诊疗增值服务。切合远程医疗、诊疗场景，为诊疗过程中的高清音、视频、低延迟沟通提供支持。",
          more: "",
          type: "videoDiagnosis",
          id: "images4",
          changeType: true
        },
        {
          icon: require("../../assets/video/video6.png"),
          iconPosition: "right",
          title: "视频定损",
          tips:
            "适用于保险公司对车险现场进行远程定损。出险后无须定损员现场处理，只需批量上传涉险车辆、环境照片，即可完成在线报险。",
          more: "",
          type: "videoLoss",
          id: "images5",
          changeType: false
        },
        {
          icon: require("../../assets/video/video7.png"),
          iconPosition: "left",
          title: "视频面试",
          tips:
            "AI虚拟机器人自动化搜索人才简历，自动化初筛、初沟通并且实时记录候选人的情绪变化、肢体语言，回答质量等数据。综合分析，向HR团队实时反馈。",
          more: "",
          type: "videoInterview",
          id: "images6",
          changeType: true
        }
      ]
    };
  },
  mounted() {},
  methods: {
    moreModel(item) {
      this.$router.push({
        path: "/videoDetail",
        query: { type: item.type }
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
